var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerritoriesWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_1350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6084 12.225L12.15 15.6833C12.0167 15.8167 11.8917 16.075 11.8584 16.2583L11.6667 17.5833C11.6 18.0583 11.9334 18.4 12.4084 18.325L13.7334 18.1333C13.9167 18.1083 14.175 17.975 14.3084 17.8417L17.7667 14.3833C18.3584 13.7917 18.6417 13.0917 17.7667 12.2167C16.9 11.35 16.2084 11.625 15.6084 12.225Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1166 12.7167C15.4083 13.7667 16.2333 14.5833 17.2833 14.8833L15.1166 12.7167Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69165 12.1917C1.69165 12.2167 1.67499 12.25 1.67499 12.275C2.44165 13.8083 3.69165 15.0667 5.22499 15.825C5.24999 15.825 5.28332 15.8083 5.30832 15.8083C5.02499 14.8417 4.80832 13.85 4.64999 12.8583C3.64999 12.6917 2.65832 12.475 1.69165 12.1917Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8917 5.35833C15.1084 3.71667 13.7834 2.39167 12.15 1.61667C12.45 2.60833 12.7 3.625 12.8667 4.64167C13.8834 4.80833 14.9 5.05 15.8917 5.35833Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60834 5.35833C2.60834 5.05833 3.625 4.80833 4.64167 4.64167C4.80834 3.65 5.01667 2.66667 5.3 1.7C5.275 1.7 5.24167 1.68333 5.21667 1.68333C3.65 2.45833 2.375 3.76667 1.60834 5.35833Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5167 4.46667C11.3167 3.38333 11.0667 2.3 10.7083 1.25C10.6917 1.19167 10.6917 1.14167 10.6833 1.075C10.0667 0.925 9.41667 0.833333 8.75 0.833333C8.075 0.833333 7.43334 0.925 6.80834 1.08333C6.8 1.14167 6.80834 1.19167 6.79167 1.25833C6.44167 2.30833 6.18334 3.38333 5.98334 4.46667C7.825 4.26667 9.675 4.26667 11.5167 4.46667Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46665 5.98333C3.37498 6.18333 2.30831 6.44167 1.24998 6.79167C1.19165 6.80833 1.14165 6.80833 1.08331 6.81667C0.92498 7.43333 0.833313 8.08333 0.833313 8.75C0.833313 9.425 0.92498 10.0667 1.08331 10.6917C1.14165 10.7 1.19165 10.6917 1.25831 10.7083C2.30831 11.0583 3.38331 11.3167 4.47498 11.5167C4.26665 9.675 4.26665 7.825 4.46665 5.98333Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4167 6.81667C16.3584 6.81667 16.3084 6.80833 16.2417 6.79167C15.1917 6.44167 14.1084 6.18333 13.025 5.98333C13.2334 7.825 13.2334 9.675 13.025 11.5083C14.1084 11.3083 15.1917 11.0583 16.2417 10.7C16.3 10.6833 16.35 10.6917 16.4167 10.6833C16.5667 10.0583 16.6667 9.41667 16.6667 8.74167C16.6667 8.08333 16.575 7.44167 16.4167 6.81667Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98334 13.0333C6.18334 14.125 6.43334 15.2 6.79167 16.25C6.80834 16.3083 6.8 16.3583 6.80834 16.425C7.43334 16.575 8.075 16.6667 8.75 16.6667C9.41667 16.6667 10.0667 16.575 10.6833 16.4167C10.6917 16.3583 10.6917 16.3083 10.7083 16.2417C11.0583 15.1917 11.3167 14.1167 11.5167 13.025C10.6 13.125 9.675 13.2 8.75 13.2C7.825 13.2 6.9 13.1333 5.98334 13.0333Z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79169 5.79167C5.54169 7.75833 5.54169 9.74167 5.79169 11.7167C7.75835 11.9667 9.74169 11.9667 11.7167 11.7167C11.9667 9.75 11.9667 7.76667 11.7167 5.79167C9.74169 5.54167 7.75835 5.54167 5.79169 5.79167Z",
    fill: "#F5F6FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritoriesWhiteIcon);
export default __webpack_public_path__ + "static/media/territories-white-icon.54d6bca2dd48bd378f632428e4ed5aa4.svg";
export { ForwardRef as ReactComponent };